"use strict";
exports.__esModule = true;
exports.SvgLock = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgLock = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 14 14" }, props),
    react_1["default"].createElement("g", { fill: "none", fillRule: "evenodd" },
        react_1["default"].createElement("path", { fill: "currentColor", stroke: "currentColor", strokeWidth: 0.583, d: "M7 2.191c-1.62 0-2.042 1.176-2.042 2.625h-.875c0-1.933.602-3.5 2.917-3.5 2.242 0 2.877 1.471 2.915 3.32l.002.18h1.215c.322 0 .583.262.583.584v6.748a.583.583 0 01-.583.583H2.869a.582.582 0 01-.583-.583V5.4c0-.322.26-.584.583-.584h6.173c0-1.45-.422-2.625-2.042-2.625zm3.84 3.5H3.16v6.165h7.68V5.691zM7 7.291a.876.876 0 01.438 1.633v1.139a.438.438 0 01-.876-.001V8.925A.875.875 0 017 7.293z" }),
        react_1["default"].createElement("path", { d: "M0 0h14v14H0z" })))); };
//# sourceMappingURL=Lock.js.map